import { PicklistDataItem } from "../../../../Engine/Core/Picklists/PicklistTypes";
import { TreePicklistProps } from "../TreePicklist/TreePicklist";
import { PicklistProps } from "../Picklist";

export const changeRelatedFields = (
    value: string,
    list: PicklistDataItem[],
    props: TreePicklistProps | PicklistProps
): void => {
    const { setDependence, searchByField, searchFields, mapChangesField } = props;

    const itemsByValue = list.filter(item => item[searchByField]?.toString() === value);

    // NOTE В случае, если зависимое поле оказалось пустое, берем первый найденный элемент
    const relatedField =
        itemsByValue.find(item =>
            Object.keys(searchFields).every(
                (searchField: string) => item[searchField]?.toString() === searchFields[searchField]?.toString()
            )
        ) || itemsByValue[0];

    const changesExcludeValue = mapChangesField.filter(changesField => changesField !== searchByField);

    changesExcludeValue.forEach(fieldName => setDependence(fieldName, relatedField?.[fieldName]?.toString() ?? ""));
};
